import { useRef, useCallback } from 'react';

export function useDoubleTap(callback, { delay = 300 } = {}) {
  const lastTapRef = useRef(0);

  const onTouchEnd = useCallback((e) => {
    const now = Date.now();
    if (now - lastTapRef.current < delay) {
      e.preventDefault();
      callback(e);
      lastTapRef.current = 0;
    } else {
      lastTapRef.current = now;
    }
  }, [callback, delay]);

  return { onTouchEnd };
}
